import { Space, Form, Select, Typography } from 'antd';

import { PREFIX as GLOBAL_PREFIX } from '@app/constants/appPrefix';

import {
  HOURS_ARRAY,
  SHORTED_HOURS,
  MINUTES_ARRAY,
  DAYS_ARRAY,
} from '@pages/Notifications/constants/hoursWithMinutes';

import '@pages/Notifications/styles/LabelWithTime.desktop.scss';

type LabelWithTimeProps = {
  componentClassName: string;
  type: 'after' | 'before';
  minutesFormItemName: string;
  hoursFormItemName: string;
  onHoursChange: (value: number) => void;
  onMinutesChange: (value: number) => void;
  hoursValue: number;
  minutesValue: number;
  withExtendedHours?: boolean;
  showDays?: boolean;
  daysFormItemName?: string;
  disabled?: boolean;
};

const { Text } = Typography;

export const LabelWithTime = ({
  componentClassName,
  type,
  minutesFormItemName,
  hoursFormItemName,
  onHoursChange,
  onMinutesChange,
  hoursValue,
  minutesValue,
  withExtendedHours = false,
  showDays = false,
  daysFormItemName = '',
  disabled = false,
}: LabelWithTimeProps) => {
  const hoursOptions = withExtendedHours ? HOURS_ARRAY : SHORTED_HOURS;

  return (
    <Space align="center">
      <Text data-testid="notification-time-text">
        Уведомление {type === 'after' ? 'через' : 'за'}
      </Text>

      {showDays && (
        <>
          <Form.Item
            className={`${GLOBAL_PREFIX}notification-label-with-time__select ${componentClassName}__select`}
            name={daysFormItemName}
          >
            <Select
              popupMatchSelectWidth={false}
              value={hoursValue}
              options={DAYS_ARRAY.map((day) => ({
                label: day,
                value: day,
              }))}
              onChange={onHoursChange}
              disabled={disabled}
            />
          </Form.Item>
          <Text>д</Text>
        </>
      )}

      <Form.Item
        className={`${GLOBAL_PREFIX}notification-label-with-time__select ${componentClassName}__select`}
        name={hoursFormItemName}
      >
        <Select
          popupMatchSelectWidth={false}
          value={hoursValue}
          options={hoursOptions.map((hour) => ({
            label: hour,
            value: hour,
          }))}
          onChange={onHoursChange}
          className="hour-select"
          popupRender={(menu) => <div data-testid="hours-dropdown">{menu}</div>}
          optionRender={(option) => (
            <span data-testid="hours-item">{option.label}</span>
          )}
          disabled={disabled}
        />
      </Form.Item>
      <Text>ч</Text>

      <Form.Item
        className={`${GLOBAL_PREFIX}notification-label-with-time__select ${componentClassName}__select`}
        name={minutesFormItemName}
      >
        <Select
          popupMatchSelectWidth={false}
          value={minutesValue}
          options={MINUTES_ARRAY.map((minute) => ({
            label: minute,
            value: minute,
          }))}
          onChange={onMinutesChange}
          className="minutes-select"
          popupRender={(menu) => (
            <div data-testid="minutes-dropdown">{menu}</div>
          )}
          optionRender={(option) => (
            <span data-testid="minutes-item">{option.label}</span>
          )}
          disabled={disabled}
        />
      </Form.Item>
      <Text>мин</Text>
    </Space>
  );
};
